exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tags-input[data-v-4a2297bc]{display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;box-shadow:0 0 .15rem rgba(0,0,0,.3);font-size:.75rem;padding:.1rem 0}.placeholder[data-v-4a2297bc]{display:inline-block;color:#a9a9a9;line-height:2em;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4a2297bc&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/input.vue
// module id = 3
// module chunks = 0